/**
 * Font-face CSS data for the PollHero widget.
 * Returns @font-face declarations for all supported fonts,
 * loading woff2 files from the configured API URL.
 */

/**
 * Returns the @font-face CSS string for all supported fonts.
 * @param {string} apiUrl - The base API URL where font files are hosted.
 * @returns {string} CSS string containing all @font-face declarations.
 */
export function getFontData(apiUrl) {
    return `
        @font-face {
            font-family: 'Montserrat';
            font-style: normal;
            font-weight: 400;
            src: url('${apiUrl}/fonts/montserrat-v29-latin-regular.woff2') format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
        }
        @font-face {
            font-family: 'Merriweather';
            font-style: normal;
            font-weight: 400;
            src: url('${apiUrl}/fonts/merriweather-v31-latin-regular.woff2') format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
        }
        @font-face {
            font-family: 'Fira Sans';
            font-style: normal;
            font-weight: 400;
            src: url('${apiUrl}/fonts/fira-sans-v17-latin-regular.woff2') format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
        }
        @font-face {
            font-family: 'Lato';
            font-style: normal;
            font-weight: 400;
            src: url('${apiUrl}/fonts/lato-v24-latin-regular.woff2') format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
        }
        @font-face {
            font-family: 'Open Sans';
            font-style: normal;
            font-weight: 400;
            src: url('${apiUrl}/fonts/open-sans-v40-latin-regular.woff2') format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
        }
        @font-face {
            font-family: 'Roboto';
            font-style: normal;
            font-weight: 400;
            src: url('${apiUrl}/fonts/roboto-v47-latin-regular.woff2') format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
        }
        @font-face {
            font-family: 'Roboto Condensed';
            font-style: normal;
            font-weight: 400;
            src: url('${apiUrl}/fonts/roboto-condensed-v27-latin-regular.woff2') format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
        }`;
}
